<template>
  <div class="lad-landing-start-your-adventure__custom">
    <div class="content-banner">
      <h3>{{ $t(`${base}.title`) }}</h3>
      <p>{{ $t(`${base}.description`) }}</p>
      <a
        :href="whatsappLink"
        target="_blank"
        class="el-button el-button--medium"
        @click="handleClickWhatsapp"
      >
        <i class="fab fa-whatsapp" />
        {{ $t(`${base}.cta`) }}
      </a>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { objet2qs } from '@/utils'
import LadParams from '@/utils/mixin/lad-params'
import CacheComponentMixin from '@/utils/mixin/cache-components'
import AnalyticsWhatsappLeadMixin from '@/utils/mixin/analytics-whatsapplead'

export default {
  name: 'LadLandingStartYourAdventureCustom',
  mixins: [AnalyticsWhatsappLeadMixin, CacheComponentMixin, LadParams],
  data() {
    return {
      base: 'landing.start_your_adventure',
      contactInfo: { customer_service: { whatsapp: [''] } },
    }
  },
  computed: {
    ...mapState('settings', ['locale']),
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      name: (state) => state.experience.name,
      isLad: (state) => state.experience.is_lad,
      exExperience: (state) => ({
        uuid: state.experience.uuid,
        type: state.experience.type,
      }),
    }),
    whatsappLink() {
      const phone = this.contactInfo.customer_service.whatsapp[0]

      const qs = objet2qs(this.params)
      const currentLink =
        qs.trim() === ''
          ? `${process.env.APP_URL}${this.$route.path}`
          : `${process.env.APP_URL}${this.$route.path}?${qs}`

      const text = this.$t(`${this.base}.whatsapp_message`, {
        name: this.name,
        link: encodeURIComponent('\n\n\n' + currentLink),
      })

      return this.isMobile
        ? `whatsapp://send?phone=${phone.replace(/ /g, '')}&text=${text}`
        : `https://wa.me/${phone.replace(/ |\+/g, '')}?text=${text}`
    },
  },
  watch: {
    locale: {
      immediate: true,
      handler(value) {
        this.contactInfo = require(`@/db/contact/${value.toLowerCase()}`).default
      },
    },
  },
}
</script>

<style lang="scss">
.lad-landing-start-your-adventure {
  &__custom {
    background-color: #fff;
    padding: 24px 20px;

    .content-banner {
      padding: 24px 20px;
      border-radius: 6px;
      border: 1px solid #ccc;

      h3 {
        font-size: 20px;
        font-weight: 700;
        line-height: 22px;
        text-align: center;
        color: #221f20;
        margin: 0 0 15px;
      }

      p {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        text-align: center;
        color: #221f20;
        margin: 0 0 15px;
      }

      .el-button {
        background-color: #0a960c;
        width: 100%;
        gap: 8px;
        border-radius: 4px;
        padding: 16px;
        border: unset;
        // font styles
        font-size: 16px;
        font-weight: 500;
        line-height: 14px;
        text-align: center;
        color: #fff;

        i {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
